module.exports = __webpack_public_path__ + "img/feature-2.7a9fb5e4.jpg";